import { Typography, Stack, Button } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import { useToast } from "hooks";

export const CopyButton = (props: { title: string; value: string }) => {
  const { title, value } = props;

  const { showSuccess } = useToast();

  return (
    <Stack direction="row" alignItems="center">
      <Typography variant="body2" color="rgba(0, 0, 0, 0.5)">
        {title}
      </Typography>
      <Button
        onClick={() => {
          navigator.clipboard.writeText(value);
          showSuccess("Copied to clipboard");
        }}
        style={{ height: "28px" }}
        endIcon={<ContentCopyIcon />}
      >
        {value}
      </Button>
    </Stack>
  );
};
